export default function faq () {

	const toggles = document.querySelectorAll('section.faq .faq-toggle:not([data-initialised])');

	if (! toggles.length) return;

	toggles.forEach(function (toggle) {

		toggle.setAttribute('data-initialised', '');

		toggle.addEventListener('click', function () {

			const expanded = toggle.getAttribute('aria-expanded') === 'true';
			const targetId = toggle.getAttribute('aria-controls');
			const target = targetId ? document.getElementById(targetId) : null;

			toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
			if (target) target.classList.toggle('is-open', ! expanded);

		});

	});

}



/*
	ACF Blocks v3 re-fetches and re-renders this block's preview markup
	inside the editor (eg. on attribute change) without a page reload, so
	'DOMContentLoaded' only covers the first render - re-run init on every
	preview refresh too. ACF's block-preview JS may run in the iframe's own
	window or in the parent admin window depending on context, so check both.
*/
const acfInstance = (typeof window !== 'undefined')
	? (window.acf || (window.parent !== window && window.parent.acf))
	: null
;

if (acfInstance) {
	acfInstance.addAction('render_block_preview/type=faq', faq);
}
